import React from 'react'
import data from './Data'
import Project from "./Project"
function Works() {

    return (
        <div className='projects_container container grid'>
            {
                data.map((project) => {
                    return (<Project id={project.id} data={project} />);
                })
            }
        </div>
    )
}

export default Works